/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  CreateBrandMutationRequest,
  CreateBrandMutationResponse,
  CreateBrand400,
} from '../types/CreateBrand'

function getCreateBrandUrl() {
  const res = {
    method: 'POST',
    url: `/api/v1/products/catalog/brands/` as const,
  }
  return res
}

/**
 * @description Create a new brand.
 * @summary Create a new brand
 * {@link /api/v1/products/catalog/brands/}
 */
export async function createBrand(
  data: CreateBrandMutationRequest,
  config: Partial<RequestConfig<CreateBrandMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateBrandMutationResponse,
    ResponseErrorConfig<CreateBrand400>,
    CreateBrandMutationRequest
  >({
    method: 'POST',
    url: getCreateBrandUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
